import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BnkComponent } from './bnk.component';
import {MainDetailComponent} from './components/main-detail/main-detail.component';
import { BnkPartnerComponent } from './components/bnk-partner/bnk-partner.component';
import { SubDetailComponent } from './components/sub-detail/sub-detail.component';
import { BnkDetailComponent } from './components/bnk-detail/bnk-detail.component';
import { BnkFooterComponent } from './components/bnk-footer/bnk-footer.component';



@NgModule({
  declarations: [
      BnkComponent,
      MainDetailComponent,
      BnkPartnerComponent,
      SubDetailComponent,
      BnkDetailComponent,
      BnkFooterComponent
  ],
  imports: [
    CommonModule
  ]
})
export class BnkModule { }
